export default function parseRange(range) {
  if (range.includes(',')) {
    const [startDate, endDate] = range.split(',');
    return {
      start_date: startDate,
      end_date: endDate,
    };
  }
  return {
    range,
  };
}
